import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { registerLibTranslations } from 'core';
import { PlanxgoComponent } from './planxgo.component';
import { PLANXGO_TRANSLATIONS } from './i18n/planxgo.translations';

const routes: Routes = [{ path: '', component: PlanxgoComponent }];

@NgModule({
  declarations: [PlanxgoComponent],
  imports: [RouterModule.forChild(routes)],
  exports: [PlanxgoComponent],
})
export class PlanxgoModule {
  constructor(translate: TranslateService) {
    registerLibTranslations(translate, PLANXGO_TRANSLATIONS);
  }
}
